import PropTypes from 'prop-types';
import React from 'react';
import { Container, ScrollableArea } from '../Components/Layout';
import { Header } from '../Components';

export default class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };
  componentDidMount(){
    let orientation = window.screen.orientation;
    if(orientation && window.screen.availHeight <= 430){
      orientation.lock("portrait");
    }
  }

  componentWillUnmount(){
    let orientation = window.screen.orientation;
    if(orientation){
      orientation.unlock();
    }
  }
  render() {
    const { children } = this.props;
    return (<Container>
      <Header />
      <ScrollableArea>
      {children}
      </ScrollableArea>
     </Container>);
  }
}
